import { useLanguage } from "@/i18n";
import { Reveal, SectionHeader } from "@/components/Reveal";

const IMAGES = [
  "https://images.unsplash.com/photo-1763854492909-1a22e0b4e013?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxwYXJpcyUyMGJhc2VsJTIwYXJjaGl0ZWN0dXJlJTIwaGlzdG9yaWMlMjBjaXR5fGVufDB8fHx8MTc5MjQ5MjExN3ww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/31716417/pexels-photo-31716417.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1764604955272-26b0864fbd51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxzYXJhamV2byUyMHByaXpyZW4lMjBiYWxrYW4lMjBoaXN0b3JpYyUyMGNpdHl8ZW58MHx8fHwxNzkyNDkyMTI5fDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/40306724/pexels-photo-40306724.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const CitiesSection = () => {
  const { t } = useLanguage();

  return (
    <section id="zones" className="py-24 sm:py-32 bg-midnight border-y border-hairline/60" data-testid="cities-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeader eyebrow={t.cities.eyebrow} title={t.cities.title} sub={t.cities.sub} />

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.cities.items.map((city, i) => (
            <Reveal key={city.name} delay={0.08 * i}>
              <div
                data-testid={`city-card-${i}`}
                className="group relative aspect-[3/4] rounded-lg overflow-hidden border border-hairline hover:border-gold/50 transition-colors duration-500"
              >
                <img
                  src={IMAGES[i]}
                  alt={`${city.name} — ${city.country}`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/40 to-obsidian/10" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-gold">{city.country}</p>
                  <h3 className="mt-1 font-serif text-3xl font-semibold text-ivory">{city.name}</h3>
                  <p className="mt-1 text-xs text-slate-300 italic font-serif">{city.tag}</p>
                  <p className="mt-3 text-[13px] leading-relaxed text-slate-300/90 opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-40 transition-all duration-500">
                    {city.blurb}
                  </p>
                  <p className="mt-3 font-mono text-[10px] tracking-widest text-ivory/50">{city.coords}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
